import { Reveal } from "@/components/Reveal";

export const VideoSection = () => (
    <section data-testid="video-section" className="py-24 md:py-32">
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
            <Reveal>
                <p className="text-xs uppercase tracking-[0.35em] text-[#d4af37] mb-4 text-center">Watch Us Live</p>
                <h2 className="font-serif text-4xl sm:text-5xl tracking-tight font-light text-[#fafafa] text-center">
                    Hear it <em className="text-[#d4af37]">before you book it.</em>
                </h2>
            </Reveal>
            <Reveal delay={0.15}>
                <div className="mt-12 relative border border-white/10 glow-gold" data-testid="youtube-embed-wrapper">
                    <div className="aspect-video w-full">
                        <iframe
                            data-testid="youtube-embed"
                            className="w-full h-full"
                            src="https://www.youtube.com/embed/BUl4TYb1rtk"
                            title="Allen G. Orchestra - LIVE (Top 40 / Latin)"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            loading="lazy"
                        />
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);
